export default "__VITE_ASSET__k75xw8eI__"